import React from 'react';
import styles from './styles.module.css';
import LiveDot from './LiveDot';

export default function Badge({
  text,
  className = '',
  dotClass = '',
}: {
  text?: string;
  className?: string;
  dotClass?: string;
}) {
  return (
    <div className={`${styles.badge} ${className}`}>
      <LiveDot className={`${styles.dotClass}`} />
      <span className={styles.badgeText}>{text}</span>
    </div>
  );
}
